import { CommunityFeatureFlagsDto, UserDto, UserFeatureFlagsDto } from '../models/dto';

export type UserAnalyticsFeatureFlagsDto = {
	user: UserFeatureFlagsDto;
	community: CommunityFeatureFlagsDto;
}

export const getFeatureFlagsPropsForAnalytics = (user?: UserDto | null, community?: UserDto | null): UserAnalyticsFeatureFlagsDto => {
	const userFeatureFlags = user?.featureFlags ?? {};
	const communityFeatureFlags = community?.featureFlags ?? {};

	return {
		user: userFeatureFlags as unknown as UserFeatureFlagsDto,
		community: communityFeatureFlags as unknown as CommunityFeatureFlagsDto,
	};
}
